<template>
  <div>
    <div class="l-container">
      <p></p>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
    // getStudentfiles (id) {
    //   this.$store.dispatch('getStudentfiles', id)
    // },
    // getStudents (id) {
    //   this.$store.dispatch('getStudentsLimit10', id)
    // }
    getCompanies () {
      this.$store.dispatch('getCompanies')
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // vm.getStudentfiles(to.params.id)
      // vm.getStudents(to.params.id)
      vm.getCompanies()
    })
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Studentfiles.vue?75898167